import script from "./Subpage2.vue?vue&type=script&setup=true&lang=js"
export * from "./Subpage2.vue?vue&type=script&setup=true&lang=js"

import "./Subpage2.vue?vue&type=style&index=0&id=1e1c3ff3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1c3ff3"]])

export default __exports__